import { useState } from "react";
import { BACKEND_URL } from "../lib/api";

const resolve = (url) => {
  if (!url) return null;
  return url.startsWith("/api") ? `${BACKEND_URL}${url}` : url;
};

const initialsOf = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase() || "·";

/**
 * Editorial circular avatar.
 * Falls back to initials on missing URL OR if the image fails to load (404, broken host, etc.)
 */
export const Avatar = ({ src, name = "", size = "md", className = "", testid }) => {
  const sizes = {
    sm: "w-7 h-7 text-[10px]",
    md: "w-10 h-10 text-xs",
    lg: "w-16 h-16 text-sm",
    xl: "w-32 h-32 text-2xl",
  };
  const resolved = resolve(src);
  const [errored, setErrored] = useState(false);
  const showImage = resolved && !errored;
  return (
    <div
      data-testid={testid}
      className={`${sizes[size] || sizes.md} rounded-full overflow-hidden border border-[#E5E0D8] bg-[#F4EFE6] flex items-center justify-center flex-shrink-0 ${className}`}
    >
      {showImage ? (
        <img
          src={resolved}
          alt={name || "avatar"}
          onError={() => setErrored(true)}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <span className="font-serif-display text-[#1E3A8A] tracking-wide">{initialsOf(name)}</span>
      )}
    </div>
  );
};

export default Avatar;
